import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=5bb070f4&scoped=true&"
import script from "./NotificationMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationMenu.vue?vue&type=script&lang=js&"
import style0 from "./NotificationMenu.vue?vue&type=style&index=0&id=5bb070f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb070f4",
  null
  
)

export default component.exports